import type { VirtualFile } from "@pdfking/pdfengine"
import type { SearchCacheBackend } from "@pdfking/storage"
import { RecordCreate } from "@pdfking/tfunc"

import download_files from "../actions/download_files"
import type { FileStorage } from "../types/FileStorage"

export async function CacheStorage(
  cache: SearchCacheBackend<VirtualFile>
): Promise<FileStorage> {
  return {
    ...cache,
    async open(names: string[]): Promise<void> {
      return download_files(
        RecordCreate(names, await Promise.all(names.map(cache.get)))
      )
    },
  }
}
